import React from 'react';
import {
  arrayOf,
  shape,
  string,
  number,
} from 'prop-types';
import {
  BlogPane,
  Block,
  Button,
  Link,
} from 'components/common';
import './BlogPanel.scss';

const BlogPanel = (
  {
    heading,
    subheading,
    blogArticles = [],
    viewMoreCta,
    imageWidth,
  },
) => (
  <div className="result-page-blog-panel" data-selector-type="blog-panel">
    <Block>
      <Block.Header
        title={heading}
        subtitle={subheading}
      />
      <div className="blogs-wrapper">
        <div className="blogs-row-wrapper">
          {blogArticles && blogArticles.map((blog, idx) => (
            <div className="blog-wrapper" key={blog.title} data-selector-type="blog-panel-row" data-selector-index={idx}>
              <BlogPane {...blog} imageWidth={imageWidth} />
            </div>
          ))}
        </div>
      </div>
      <div>
        {viewMoreCta && (
          <Link to={viewMoreCta.href}>
            <Button styleName="ghost" ightIconName="chevron_forward">
              {viewMoreCta.title}
            </Button>
          </Link>
        )}
      </div>
    </Block>
  </div>
);

BlogPanel.defaultProps = {
  heading: '',
  subheading: '',
  blogArticles: null,
  viewMoreCta: null,
  imageWidth: null,
};

BlogPanel.propTypes = {
  blogArticles: arrayOf(shape({
    image: shape({
      url: string.isRequired,
      description: string,
    }).isRequired,
    title: string.isRequired,
    description: string.isRequired,
    link: string.isRequired,
  })),
  subheading: string,
  heading: string,
  viewMoreCta: shape({}),
  imageWidth: number,
};

export default BlogPanel;
